import { adjustDate } from '../../lib/utils';

const INITIAL_STATE = {
    open: false,
    range: {
        start: adjustDate(0,0),
        end: adjustDate(23,59)
    },
};

export default function(state = INITIAL_STATE, action) {
    switch(action.type) {
        case "OPEN_EXPORT_DIALOG":
            return {...state, open: true};
        case "CANCEL_EXPORT_DIALOG":
            return {...state, open: false};
        case "CLOSE_EXPORT_DIALOG":
            return {...state, open: false, range: {...action.range}};
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/store/reducers/fileexport.js